import React,{useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import Drawer from '@mui/material/Drawer';
import axios from 'axios'
import IconButton from '@mui/material/IconButton';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import DirectionsWalkSharpIcon from '@mui/icons-material/DirectionsWalkSharp';
import DriveEtaSharpIcon from '@mui/icons-material/DriveEtaSharp';
import DirectionsBikeSharpIcon from '@mui/icons-material/DirectionsBikeSharp';
import PlaceIcon from '@mui/icons-material/Place';
import MyLocationSharpIcon from '@mui/icons-material/MyLocationSharp';
import AsyncSelectSearch from '../FormComopents/Form/AsyncSelectSearchNav';
import { setStartCord } from '../../redux/actions/mapaction'
import { openNavDetailDialog } from '../../redux/actions/controlbuttonaction';
import { closeNavigationWindow } from '../../redux/actions/controlbuttonaction'
import { sidebarwith } from './const';
import { bgColors } from '../utils/bgColor';
import { useDispatch, useSelector} from 'react-redux';
import {fetchrootpath} from "../api_servcies/apirootpath"
import {setMapCentreCord, setVillagerevpoly, setVillSearchStr} from "../../redux/actions/mapaction"
import NavigationDetails from '../FormComopents/NavigationDetails';
import Button from '@mui/material/Button';;
const drawerWidth = sidebarwith;
const villagesearchurl = `${fetchrootpath}/searchvillage`
const villsurveypolyurl = `${fetchrootpath}/point_village/revpoly_json`

const NavigationWindow=(Props) =>{
  const {openNavigationWindow} = Props
  const dispatch = useDispatch()
  const navData = useSelector(state => state.mapreducer.navroutedata)
  const dialogopen = useSelector(state => state.controlbutton.navdetailsdialog)
  // const [selectedSource, setSelectedSource] = useState({
  //   selectedSource: ''
  //   })
  const [selectedVillage, setSelectedVillage] = useState({
    selectedVillage: ''
    })

const [height, setHeight] = useState('250px')
const onChange = selectedSource => {

    let longLat = selectedSource.long_lat
    let centercord = {
        longitude: longLat[0],
        latitude: longLat[1]
    }
    setSelectedVillage({
        ...selectedSource,
        selectedSource: selectedSource.label || []
    })
   
    dispatch(setStartCord(centercord))
}

const onChangeDestination = selectedVillage => {
  let longLat = selectedVillage.long_lat
  let centercord = {
      longitude: longLat[0],
      latitude: longLat[1]
  }
  setSelectedVillage({
      ...selectedVillage,
      selectedVillage: selectedVillage.label || []
  })
  dispatch(setVillSearchStr(selectedVillage.label))
  dispatch(setMapCentreCord(centercord))
  // dispatch(setEndCord(centercord))
}
const fetchData =  async(e) => {
const searchstr = e
if (searchstr.length>=8)
{setHeight('500px')
const response = await axios.get(villagesearchurl, {
  params: {'searchstr': searchstr},
      //  headers: {'Access-Control-Allow-Origin' : *},
      },)
  let label_data = []
  response.data.forEach((item,index) => {
      // setMarginTop('110%')
      let _label = [item.state_name, item.district_name,
                  item.subdistrict_name, item.village_name].join(',')
      let _index = index
      let _lnglat = item.village_centroid.coordinates
      let label = {
          id : _index,
          label:_label,
          long_lat: _lnglat
      }
      label_data.push(label)
      

  });
    return label_data
  }
}
const load =  async (selectedVillage) => {
    const latlong = {
        latitude:selectedVillage.long_lat[1],
        longitude:selectedVillage.long_lat[0]
    } 
    try{
        await axios.get(villsurveypolyurl, {
            params: latlong,
                },)
                .then((response)=> {
                    // console.log(response.data[0].json_build_object)
                  dispatch(setVillagerevpoly(response.data[0].json_build_object))
                   dispatch(openNavDetailDialog)
                
                }).catch(error => {
                console.error('There was an error!', error);
                });
            }
    catch (error)
    {
    console.log(error)
    }

}

useEffect(()=> {
const timer = setTimeout(() => {
    // setMarginTop('20%')
   if(selectedVillage.long_lat)
   { load(selectedVillage)}
}, 650)
return () => {
    clearTimeout(timer)
};
},[selectedVillage])

// console.log(Directionicons(navData.steps[1].maneuver.instruction))

  return (
    <>
      <Drawer
        sx={
          {
            // width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              marginTop:'0.0rem',
              marginLeft:'0.0rem',
              maxHeight:height,
              boxSizing: 'border-box',
              backgroundColor:bgColors.default_backgroun_grey,
              color:bgColors.grey_300,
              overflow:'auto',
              borderRadius:2
            },
          }
        }
      variant="persistent"
      anchor="left"
      open={openNavigationWindow}
      >
        <Grid container justifyContent="flex-end" spacing={6}
            alignItems="flex-start" 
            marginBottom = '1rem'
            // marginTop = '0.01rem'
            >
          <Grid item>
          <IconButton onClick={() => dispatch(closeNavigationWindow)} >
            <DriveEtaSharpIcon fontSize='medium' style={{color:bgColors.grey_800}}/>
          </IconButton>
          </Grid>
          <Grid item>
          <IconButton onClick={() => dispatch(closeNavigationWindow)} >
            <DirectionsWalkSharpIcon fontSize='medium' style={{color:bgColors.grey_800}}/>
          </IconButton>
          </Grid>
          <Grid item>
          <IconButton onClick={() => dispatch(closeNavigationWindow)} >
            <DirectionsBikeSharpIcon fontSize='medium' style={{color:bgColors.grey_800}}/>
          </IconButton>
          </Grid>
          <Grid item>
          <IconButton onClick={() => dispatch(closeNavigationWindow)} >
           <CloseSharpIcon fontSize='medium' style={{color:bgColors.grey_800}}/>
          </IconButton>
          </Grid>
        </Grid>
        {/* <Divider style={{color: bgColors.grey_500}}/> */}
        <Grid container sx={{ display: 'flex', 
        direction:'row', 
        marginLeft:'0.1rem',
        maxWidth:'100%'
      
      }} 
        rowSpacing={2} 
        columnSpacing={1}
        alignItems="center"
        justifyContent="center"
        >
        <Grid item xs={1}>
        <MyLocationSharpIcon fontSize='medium' style={{color:bgColors.grey_800}}/>
        </Grid>
        <Grid item xs={11}>
          <AsyncSelectSearch
             conmplete
             defaultValue={selectedVillage.selectedVillage}
             onChange = {onChange}
             // placeholder={ selectedVillage.selectedVillage}
             loadOptions = {fetchData}
          
          />
    </Grid>
    <Grid item xs={1}>
        <PlaceIcon fontSize='medium' style={{color:bgColors.grey_800}}/>
        </Grid>
        <Grid item xs={11}>
          <AsyncSelectSearch
             conmplete
             defaultValue={selectedVillage.selectedVillage}
             onChange = {onChangeDestination}
             loadOptions = {fetchData}
          />
        </Grid>
        </Grid>
        <>
        <Grid container  style={{padding:'1rem', justifyContent:'flex-end'}} >
        <Button variant="outlined" 
          onClick={() => dispatch(openNavDetailDialog)}
          >
         Nav summary
        </Button>
        </Grid>
        </>
      </Drawer>
      <NavigationDetails
        data = {navData}
        open = {dialogopen}        
        />
    </>
  );
}
export default NavigationWindow
